import { FC } from 'react';

import Box from '@mui/material/Box';
import Select, { SelectProps } from 'components/Select';
import Icon from 'components/Icon';

import { iconList } from 'icomoon-react';
import iconSet from 'assets/icons/selection.json';

const options = iconList(iconSet)
  .map((icon: string) => ({
    value: `icon-${icon}`,
    label: icon,
    icon,
  }))
  .sort((a: any, b: any) => {
    if (a.label.toLowerCase() < b.label.toLowerCase()) {
      return -1;
    }
    if (a.label.toLowerCase() > b.label.toLowerCase()) {
      return 1;
    }
    return 0;
  });

type Props = Omit<SelectProps, 'options'>;

const renderValue = (value: string) => (
  <Box sx={{ display: 'flex' }}>
    <Icon icon={value} sx={{ mr: 1, ml: 1 }} />
    {value}
  </Box>
);

const IconSelect: FC<Props> = props => (
  <Select options={options} renderValue={renderValue} {...props} />
);

export default IconSelect;
